import { formatDistanceToNow } from "date-fns";
import { id } from "date-fns/locale";

export function formatRelativeTime(dateInput: number | string): string {
  let date: Date;

  if (typeof dateInput === "number") {
    date = new Date(dateInput * 1000);
  } else {
    date = new Date(dateInput);
  }

  if (isNaN(date.getTime())) {
    return "-";
  }

  return formatDistanceToNow(date, { addSuffix: true, locale: id });
}